var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-group',{staticClass:"mt-3",attrs:{"label":_vm.labels.syncOptionsTitle}},[_c('b-form-radio-group',{attrs:{"options":_vm.syncOptions,"stacked":"","name":"radiosStacked"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }